import { FC } from 'react';
import CreateJob from 'containers/jobs/create-edit-job/CreateJob';

interface CreateJobPageProps {
  isEdit?: boolean;
}

const CreateJobPage: FC<CreateJobPageProps> = ({ isEdit = false }) => {
  return <CreateJob isEdit={isEdit} />;
};

export default CreateJobPage;
